module.exports = __webpack_public_path__ + "img/img (14).8d4c83ba.png";